import {
  Button,
  useTheme
} from '@mui/material';
import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { PlanSearchBar } from 'modules/components/layer05';
import {
  SavePlanModal,
  SavePlanSetModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import React, { useState } from 'react';



export type PlansHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlansHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Plans'
      subtitle=''
      actionButtons={<ActionButtonsGroup />}
      searchBar={<PlanSearchBar.FC />}
    />

  );
};

type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isSavePlanSetVisible,
    setIsSavePlanSetVisible
  ] = useState(false);
  const access = useAccessState('Plan');

  return (
    <>
      {isVisible && (
        <SavePlanModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      {isSavePlanSetVisible && (
        <SavePlanSetModal.FC
          id=''
          isVisible={isSavePlanSetVisible}
          handleClose={() => setIsSavePlanSetVisible(() => false)}
        />
      )}
      <Button
        variant='outlined'
        disabled={!access.create}
        color='primary'
        onClick={() => setIsSavePlanSetVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='SUITCASE'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Create new Plan Set
      </Button>
      <Button
        variant='contained'
        color='primary'
        disabled={!access.create}
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Add Plan
      </Button>

    </>
  );
};
